<mat-card class="layer-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title-group class="layer-header">
      <mat-card-title>
        <mat-checkbox [checked]="result.isSelected" (change)="selectScenarioResult($event.checked)">
          {{ result.payload.model }}
        </mat-checkbox>
      </mat-card-title>
      <!-- @if (layer.isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
      } -->
    </mat-card-title-group>
  </mat-card-header>

  @if (result.isSelected) {
    <mat-card-content class="mat-card-content">
      <div class="mat-card-info">
        <p
          class="mat-card-paragraph"
          [matTooltip]="result.payload.scenario.length > 22 ? result.payload.scenario : ''"
          matTooltipPosition="below"
        >
          Scenario: {{ result.payload.scenario }}
        </p>
        <p
          class="mat-card-paragraph"
          [matTooltip]="result.payload.variable.length > 22 ? result.payload.variable : ''"
          matTooltipPosition="below"
        >
          Variable: {{ result.payload.variable }}
        </p>

        <p class="mat-card-paragraph">Region: {{ result.payload.region }}</p>

        <p class="mat-card-paragraph">Year: {{ result.payload.year }}</p>
        @if (result.payload.subannual != 'Year' && result.payload.subannual != '') {
          <p class="mat-card-paragraph">Subannual: {{ result.payload.subannual }}</p>
        }

        <div class="mat-card-buttons">
          <button
            mat-icon-button
            aria-label="Export IAMC dataset"
            matTooltip="Export IAMC dataset"
            (click)="exportIAMCCSV()"
          >
            <mat-icon>archive</mat-icon>
          </button>
        </div>
      </div>

      <div class="mat-card-symbology">
        <app-custom-symbology [symbology]="result.layer.symbology"></app-custom-symbology>
      </div>
    </mat-card-content>
  }
</mat-card>
